import BirdsEyeView from './BirdsEyeView';

export default BirdsEyeView;